<template>
	<BaseModal
		class="offer-reporter"
		:title="$t('WEBAPP_REPORT_HEADLINE_SORRY')"
		:closable="true"
		@closed="handleIssueChange"
		ref="modal"
		@dismiss="$emit('dismiss')"
	>
		<div>
			<!-- Report Issue -->
			<div @click="openPopover">
				<div class="item vfm-item">
					<span class="item-label">{{ $t('WEBAPP_REPORT_ISSUE') }}</span>
					<span class="item-label">{{ selectedIssueTranslatable }}</span>
					<FontAwesomeIcon class="caret-down" :icon="faCaretDown" />
				</div>
				<div align="right" style="margin-inline-end: 21px" v-if="itemData.issueSelected === 'wrong_price'">
					<FontAwesomeIcon :icon="faInfoCircle" />
					<small> {{ $t('WEBAPP_REPORT_HINT_SDHD_PRICES') }} </small>
				</div>
			</div>

			<div v-if="mandatoryComment">
				<!-- Comment -->
				<div class="item vfm-item border-bottom" :class="{ disabled: !itemData.issueSelected }">
					<span class="item-label label-md">{{ $t('WEBAPP_REPORT_COMMENT') }} </span>
					<textarea
						rows="2"
						placeholder="We'll need some more details so we can work on this!"
						:disabled="!itemData.issueSelected"
						@input="$event => (itemData.commentInput = $event.target.value)"
					></textarea>
				</div>

				<!-- Checkbox -->
				<div class="item vfm-item padding-top" :class="{ disabled: !itemData.issueSelected }">
					<CheckboxInput
						v-model="itemData.stayUpdated"
						:label="$t('WEBAPP_REPORT_EMAILQUESTION')"
						:disabled="!itemData.issueSelected"
					/>
				</div>

				<!-- Email -->
				<div
					v-if="itemData.stayUpdated"
					class="item vfm-item border-bottom"
					:class="{ disabled: !itemData.issueSelected }"
				>
					<span class="item-label">{{ $t('WEBAPP_REPORT_ENTER_EMAIL') }}</span>
					<input
						id="emailValidation"
						type="email"
						pattern="[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})"
						placeholder="yourname@yourdomain.com"
						:disabled="!itemData.issueSelected"
						@input="$event => (itemData.emailInput = $event.target.value)"
					/>
				</div>
			</div>

			<div v-show="!!itemData.issueSelected && !mandatoryComment">
				<div @click="openProviderPopover">
					<div class="item vfm-item" :class="{ disabled: !itemData.issueSelected }">
						<span class="item-label">{{ $t('WEBAPP_REPORT_AFFECTEDPROVIDER') }}</span>
						<span class="item-label">{{ itemData.providerSelectedClear }}</span>
						<FontAwesomeIcon class="caret-down" :icon="faCaretDown" />
					</div>
					<div
						align="right"
						style="margin-inline-start: 185px; margin-inline-end: 21px"
						v-if="itemData.issueSelected !== '' && itemData.providerSelected === 'netflix'"
					>
						<FontAwesomeIcon :icon="faInfoCircle" />
						<small v-html="$t('WEBAPP_REPORT_HINT_NETFLIX_COUNTRY', { country: translatedCountry })">
						</small>
					</div>
				</div>

				<!-- Link to Provider's page -->
				<div class="item vfm-item border-bottom" :class="{ disabled: !itemData.issueSelected }">
					<span class="item-label" style="white-space: normal">
						{{ $t('WEBAPP_REPORT_EXTERNALLINK', { object_type: titleObjectTypeTranslation }) }} &nbsp;
						<template v-if="itemData.issueSelected !== 'missing_offer'">
							{{ $t('WEBAPP_REPORT_COMMENT_OPTIONAL') }}
						</template>
					</span>
					<input
						placeholder="https://..."
						:disabled="!itemData.issueSelected"
						@input="$event => (itemData.externalLinkInput = $event.target.value)"
					/>
				</div>

				<!-- Comment -->
				<div class="item vfm-item border-bottom" :class="{ disabled: !itemData.issueSelected }">
					<span class="item-label label-md">
						{{ $t('WEBAPP_REPORT_COMMENT') }}
						{{ mandatoryComment ? '' : $t('WEBAPP_REPORT_COMMENT_OPTIONAL') }}
					</span>
					<textarea
						rows="2"
						:placeholder="freetextPlaceholder"
						:disabled="!itemData.issueSelected"
						@input="$event => (itemData.commentInput = $event.target.value)"
					></textarea>
				</div>

				<!-- Checkbox -->
				<div class="item vfm-item padding-top" :class="{ disabled: !itemData.issueSelected }">
					<CheckboxInput
						v-model="itemData.stayUpdated"
						:label="$t('WEBAPP_REPORT_EMAILQUESTION')"
						:disabled="!itemData.issueSelected"
					/>
				</div>

				<!-- Email -->
				<div v-if="itemData.stayUpdated" class="item vfm-item border-bottom">
					<span class="item-label">{{ $t('WEBAPP_REPORT_ENTER_EMAIL') }}</span>
					<input
						id="emailValidation"
						type="email"
						pattern="[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})"
						placeholder="yourname@yourdomain.com"
						@input="$event => (itemData.emailInput = $event.target.value)"
					/>
				</div>
			</div>
		</div>

		<template v-slot:footer>
			<div style="padding: 15px">
				<span v-if="itemData.errorNotification" style="display: block; color: red; margin-bottom: 10px">{{
					$t('WEBAPP_REPORT_ERROR')
				}}</span>
				<BasicButton
					:blocked="true"
					:color="'primary'"
					@click="reportIssue()"
					:disabled="isFormInvalid || itemData.isSending"
				>
					{{ $t('WEBAPP_REPORT_REPORT') }}
				</BasicButton>
			</div>
		</template>
	</BaseModal>
</template>

<script setup lang="ts">
import { computed, reactive, ref } from 'vue';
import { faCaretDown, faInfoCircle } from '@fortawesome/free-solid-svg-icons';

import CheckboxInput from '@/ui-components/CheckboxInput.vue';
import BasicButton from '@/ui-components/BasicButton.vue';
import BaseModal from '@/components/modals/vfm/BaseModal.vue';
import OfferReporterSuccessModal from '@/components/modals/offer-reporter/OfferReporterSuccessModal.vue';

import { ModalHelper } from '@/helpers/vfm/modal-helper';
import { VFMHelper } from '@/helpers/vfm/vfm-helper';
import { PopoverHelper } from '@/helpers/vfm/popover-helper';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

import Provider from '@/interfaces/provider';

import {
	Episode,
	Movie,
	MovieContent,
	ObjectType,
	Offer,
	Platform,
	Season,
	SeasonContent,
	Show,
	ShowContent,
	UpcomingRelease,
} from '@/@types/graphql-types';
import {
	ReportFeedbackDocument,
	ReportFeedbackMutation,
	ReportFeedbackMutationVariables,
} from '@/graphql/mutation/ReportFeedback.mutation';
import { SnowplowContext } from '@/helpers/tracking/providers';
import {
	GetSportProvidersByShortNamesDocument,
	GetSportProvidersByShortNamesQuery,
	GetSportProvidersByShortNamesQueryVariables,
} from '@/features/sports/graphql/queries/GetSportProvidersByShortNames.query';
import {
	GetTitleProvidersByShortNamesDocument,
	GetTitleProvidersByShortNamesQuery,
	GetTitleProvidersByShortNamesQueryVariables,
} from '@/pages/graphql/queries/GetTitleProvidersByShortNames.query';
import { useConstantStore } from '@/stores/pinia/useConstantStore';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';

export type OfferReporterModalTitle = Pick<Movie | Show | Season | Episode, 'objectId' | 'objectType'> &
	Pick<MovieContent | ShowContent | SeasonContent, 'scoring'>;

const issueName = {
	mismatch: 'MISMATCH',
	title_not_available: 'TITLE_NOT_AVAILABLE',
	missing_offer: 'MISSING_OFFER',
	wrong_price: 'WRONG_OFFER',
	wrong_info: 'WRONG_INFO',
	bug: 'BUG',
	other: 'OTHER',
};

const props = withDefaults(
	defineProps<{
		titleId: string;
		titleObjectId: number;
		titleObjectType:
			| ObjectType.Movie
			| ObjectType.ShowSeason
			| ObjectType.Show
			| ObjectType.ShowEpisode
			| ObjectType.SportEvent;
		titleName: string;
		originalReleaseYear?: number;
		titleOffers?: Offer[] | UpcomingRelease[];
		additionalContexts?: SnowplowContext[];
	}>(),
	{
		titleOffers: () => [],
		additionalContexts: () => [],
	}
);

const { t } = useI18n();
const { providers } = useConstantStore();
const { language, country, webLocale } = storeToRefs(useLanguageStore());
const modal = ref<InstanceType<typeof BaseModal> | null>(null);

const itemData = reactive({
	commentInput: '',
	emailInput: '',
	errorNotification: false,
	externalLinkInput: '',
	isSending: false,
	issueSelected: '',
	providerSelected: '',
	providerSelectedClear: '',
	stayUpdated: false,
});

const queryVariables = computed<GetSportProvidersByShortNamesQueryVariables>(() => ({
	country: country.value,
	platform: Platform.Web,
}));

const sportProvidersByShortNamesQueryOptions = computed(() => ({
	enabled: props.titleObjectType === ObjectType.SportEvent,
}));
const { result: sportProvidersByShortNamesData } = useQuery<
	GetSportProvidersByShortNamesQuery,
	GetSportProvidersByShortNamesQueryVariables
>(GetSportProvidersByShortNamesDocument, queryVariables, sportProvidersByShortNamesQueryOptions);
const sportProvidersByShortName = computed(() =>
	(sportProvidersByShortNamesData.value?.packages || []).map(({ shortName }) => shortName)
);

const titleProvidersByShortNamesQueryOptions = computed(() => ({
	enabled: props.titleObjectType !== ObjectType.SportEvent,
}));
const { result: titleProvidersByShortNamesData } = useQuery<
	GetTitleProvidersByShortNamesQuery,
	GetTitleProvidersByShortNamesQueryVariables
>(GetTitleProvidersByShortNamesDocument, queryVariables, titleProvidersByShortNamesQueryOptions);
const titleProvidersByShortName = computed(() =>
	(titleProvidersByShortNamesData.value?.packages || []).map(({ shortName }) => shortName)
);

const { mutate } = useMutation<ReportFeedbackMutation, ReportFeedbackMutationVariables>(ReportFeedbackDocument);

const titleObjectTypeTranslation = computed(() => {
	const objectTypeTranslations = {
		[ObjectType.Movie]: t('WEBAPP_MOVIE'),
		[ObjectType.Show]: t('WEBAPP_SHOW'),
		[ObjectType.ShowSeason]: t('WEBAPP_SEASON'),
		[ObjectType.ShowEpisode]: t('WEBAPP_EPISODE'),
		[ObjectType.SportEvent]: t('WEBAPP_EVENT'),
	};

	return objectTypeTranslations[props.titleObjectType].toLowerCase();
});

const issues = computed(() => {
	const object_type = titleObjectTypeTranslation.value;
	const object_type_capitalized = capitalize(titleObjectTypeTranslation.value);

	// the keys are values expected from the backend
	// translation keys need to be present in whole for automatic cleaning
	return [
		{
			technical_name: 'mismatch',
			translatable: t('WEBAPP_REPORT_ISSUE_MISMATCH', { object_type, object_type_capitalized }),
		},
		{
			technical_name: 'title_not_available',
			translatable: t('WEBAPP_REPORT_ISSUE_MISSING_TITLE_NOT_AVAILABLE', {
				object_type,
				object_type_capitalized,
			}),
		},
		{
			technical_name: 'missing_offer',
			translatable: t('WEBAPP_REPORT_ISSUE_MISSING_OFFER', { object_type, object_type_capitalized }),
		},
		{
			technical_name: 'wrong_price',
			translatable: t('WEBAPP_REPORT_ISSUE_WRONG_PRICE', { object_type, object_type_capitalized }),
		},
		{
			technical_name: 'wrong_info',
			translatable: t('WEBAPP_REPORT_ISSUE_METADATA', { object_type, object_type_capitalized }),
		},
		{
			technical_name: 'bug',
			translatable: t('WEBAPP_REPORT_ISSUE_BUG', { object_type, object_type_capitalized }),
		},
		{
			technical_name: 'cant_watch',
			translatable: t('WEBAPP_REPORT_ISSUE_CANT_WATCH', { object_type, object_type_capitalized }),
		},
		{
			technical_name: 'other',
			translatable: t('WEBAPP_REPORT_ISSUE_OTHER', { object_type, object_type_capitalized }),
		},
	];
});

const mandatoryComment = computed(() => ['wrong_info', 'bug', 'other'].includes(itemData.issueSelected));

const freetextPlaceholder = computed(() =>
	mandatoryComment.value ? t('WEBAPP_REPORT_REQUIRED_FREETEXTPLACEHOLDER') : t('WEBAPP_REPORT_FREETEXTPLACEHOLDER')
);

const translatedCountry = computed(() => t(`WEBAPP_COUNTRY_${webLocale.value.toUpperCase()}`));

const isFormInvalid = computed<boolean>(() => {
	const { issueSelected, stayUpdated, emailInput, commentInput, providerSelected, externalLinkInput } = itemData;
	if (issueSelected === 'missing_offer') {
		return externalLinkInput !== '' ? false : true;
	}

	if (mandatoryComment.value) {
		if (issueSelected && stayUpdated) {
			return emailInput !== '' && commentInput !== '' ? false : true;
		} else {
			return commentInput !== '' ? false : true;
		}
	} else {
		if (issueSelected && stayUpdated) {
			return emailInput !== '' && providerSelected !== '' ? false : true;
		} else {
			return providerSelected ? false : true;
		}
	}
});

const titleProviders = computed(() => {
	const items = (props.titleOffers ?? []) as (Offer | UpcomingRelease)[];
	const titleProviderIDs = items.map(offer => offer.package?.packageId).filter(Boolean);
	return providers().filter((provider: any) => titleProviderIDs.indexOf(provider.packageId) !== -1);
});

const filteredProviders = computed(() => {
	const missingProvider = {
		clearName: `(${t('WEBAPP_REPORT_MISSINGPROVIDER')})`,
		icon: '',
		monetizationTypes: [],
		packageId: 0,
		shortName: '',
		slug: '',
		technicalName: 'missing',
	} as Provider;
	const sportProviders = providers().filter((provider: Provider) =>
		sportProvidersByShortName.value.includes(provider.shortName)
	);
	const titleProvidersData = providers().filter((provider: Provider) =>
		titleProvidersByShortName.value.includes(provider.shortName)
	);
	const filtered = props.titleObjectType === ObjectType.SportEvent ? sportProviders : titleProvidersData;
	const providersData =
		itemData.issueSelected === 'missing_offer' ? filtered.slice().sort() : [...titleProviders.value].sort();
	return [missingProvider].concat(providersData);
});

const selectedIssueTranslatable = computed(
	() => issues.value.find(el => el.technical_name === itemData.issueSelected)?.translatable || '...'
);

async function openPopover(event: Event) {
	const selectedIssue = await PopoverHelper.create({
		popoverProps: {
			cssClass: 'issues-popover',
			boundingElement: event.currentTarget,
			position: 'left',
		},
		component: () => import('./IssuesListPopover.vue'),
		componentProps: {
			issues: issues.value,
			selectedIssue: itemData.issueSelected,
		},
	});

	if (!!selectedIssue) {
		handleIssueChange({ target: { value: selectedIssue } });
	}
}

function handleIssueChange(event?: any) {
	Object.assign(itemData, {
		commentInput: '',
		emailInput: '',
		errorNotification: false,
		externalLinkInput: '',
		isSending: false,
		providerSelected: '',
		providerSelectedClear: '',
		stayUpdated: false,
		issueSelected: event?.target?.value ?? '',
	});
}

async function openProviderPopover(event: Event) {
	if (!modal.value) return;

	const selectedProvider = await PopoverHelper.create({
		popoverProps: {
			cssClass: 'providers-popover',
			boundingElement: event.currentTarget,
			position: 'left',
			bottomGutter: -32,
		},
		component: () => import('./ProviderListPopover.vue'),
		componentProps: {
			providers: filteredProviders.value,
			selectedProvider: itemData.providerSelectedClear,
		},
	});

	if (!!selectedProvider) {
		handleProviderChange({ target: { value: selectedProvider } });
	}
}

function handleProviderChange(event: any) {
	const { technicalName, clearName } = event?.target?.value;

	itemData.providerSelected = technicalName ?? '';
	itemData.providerSelectedClear = clearName ?? '';
}

async function reportIssue() {
	if (itemData.isSending) return;

	itemData.isSending = true;

	const provider = providers().find((provider: Provider) => {
		return provider.technicalName === itemData.providerSelected;
	});

	try {
		if (itemData.emailInput) {
			const emailValid = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(itemData.emailInput);
			if (!emailValid) {
				itemData.errorNotification = true;
				itemData.isSending = false;
				return;
			}
		}

		await mutate({
			input: {
				id: props.titleId,
				// @ts-ignore
				type: issueName[itemData.issueSelected],
				country: country.value,
				language: language.value,
				package: provider?.shortName || '',
				comment: itemData.commentInput,
				externalUrl: itemData.externalLinkInput,
				email: itemData.emailInput,
				platformVersion: `${APP_VERSION}-${APP_PLATFORM}`,
			},
		});

		TrackingHelper.trackEvent('offer_reporter', {
			action: 'send_feedback',
			label: itemData.issueSelected ?? '',
		});

		// close current modal
		VFMHelper.close();
		// then open OfferReporterSuccessModal
		await ModalHelper.openModal(
			OfferReporterSuccessModal,
			{ email: itemData.emailInput },
			{},
			'',
			false,
			props.additionalContexts
		);
	} catch (error) {
		itemData.errorNotification = true;
	}

	itemData.isSending = false;
}

function capitalize(str: string) {
	return `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
}
</script>

<style lang="scss">
.offer-reporter {
	section {
		flex-grow: 1;
	}
}

.item {
	display: flex;
	padding: 0 16px;
	align-self: flex-start;
	cursor: pointer;

	&.border-bottom:focus-within {
		border-bottom: 2px solid #fbc500;
	}
	&.padding-top {
		padding: 16px;
	}
	&.disabled {
		opacity: 0.4;
	}
	&:hover {
		background-color: #0a151f;
	}

	.item-label {
		flex-grow: 1;
		flex-shrink: 1;
		margin: 12px 0;
		font-size: 16px;
		font-weight: 400;

		&:nth-child(2) {
			text-align: end;
		}
	}

	.label-md {
		flex: initial;
		max-width: 200px;
		pointer-events: none;
	}

	input,
	textarea {
		width: 100%;
		padding: 12px;
		font-size: 16px;
		resize: none;
		outline: none;
		background: transparent;
		border: none;
		color: inherit;
		text-align: right;

		&::placeholder {
			color: #999;
		}
	}
}

.caret-down {
	font-size: 15px;
	margin: auto;
	color: #4a4f56;
}
</style>
